import * as React from 'react'

const SvgLessionIcon = (props) => (
  <svg
    width="24"
    height="20"
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3.29459V18.4613M12 3.29459C10.6375 2.38935 8.78757 1.83301 6.75 1.83301C4.71243 1.83301 2.86254 2.38935 1.5 3.29459V18.4613C2.86254 17.556 4.71243 16.9997 6.75 16.9997C8.78757 16.9997 10.6375 17.556 12 18.4613M12 3.29459C13.3625 2.38935 15.2124 1.83301 17.25 1.83301C19.2876 1.83301 21.1375 2.38935 22.5 3.29459V18.4613C21.1375 17.556 19.2876 16.9997 17.25 16.9997C15.2124 16.9997 13.3625 17.556 12 18.4613"
      stroke="url(#paint0_linear_1081_3686)"
      strokeWidth="2.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1081_3686"
        x1="3.32609"
        y1="2.79418"
        x2="13.0644"
        y2="17.1948"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.135417" stopColor="#FF692E" />
        <stop offset="1" stopColor="#FF692E" />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgLessionIcon
